// removed by extract-text-webpack-plugin
module.exports = {"inputStock":"InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","inputStockDirty":"InputObservaciones__inputStockDirty___1kxvz InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","inputStockInvalida":"InputObservaciones__inputStockInvalida___2B40u InputObservaciones__inputStock___2XKJb shared__inputNumberAsText___1Qr9M","divConTooltip":"InputObservaciones__divConTooltip___326Gi","tooltip":"InputObservaciones__tooltip___2jalV"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/InputObservaciones.css
// module id = 744
// module chunks = 0